import {OrderDishItem, ReviewChoice} from "@globals/DailyOrders/interfaces";
import {eatClubClient} from "@globals/config/apiClient";

import {DishReviewRequest, DishReviewResponse} from "./interfaces";

export function putDishReview(
  data: DishReviewRequest
): Promise<DishReviewResponse> {
  // API returns an array of DishReviewResponse but we need only first one;
  return eatClubClient.put(`/api/v3/review/`, data).then(({data}) => data[0]);
}

export function getReview(): Promise<OrderDishItem> {
  return eatClubClient.get("/api/v3/ask-for-review/").then(({data}) => data);
}

export function getReviewChoices(rating: number): Promise<ReviewChoice[]> {
  return eatClubClient
    .get(`/api/v3/review-choices/${rating}/`)
    .then(({data}) => data);
}
